import { createContext, useContext } from 'react';
export const DuperbrowseViewContext = createContext(undefined);
DuperbrowseViewContext.displayName = 'DuperbrowseViewContext';
export function useDuperbrowseViewType() {
    const viewType = useContext(DuperbrowseViewContext);
    return {
        viewType,
        isInDuperbrowse: !!viewType
    };
}
